import { useQuery } from '@tanstack/react-query';
import { ServiceRepository } from '@packlink/packlink-sdk';
import { useSdk } from '@packlink/packlink-sdk-provider';
import { useEffect } from 'react';
import { SERVICES_LIST_CACHE_KEY } from '../constants/serviceList.js';
import { ServiceListEvents } from '../types/types.js';

function useFetchServices(searchParams, handleFetchLoading, saveFetchedServices, isAnonymousUser, onFetchError, sortBy) {
  const sdk = useSdk();
  const serviceRepository = new ServiceRepository(sdk.apiClient);
  const queryParams = {
    ...searchParams,
    ...{
      sortBy
    }
  };
  const areParamsForBulkServices = params => 'shipments' in params;
  const {
    data,
    isLoading,
    error
  } = useQuery({
    queryKey: [SERVICES_LIST_CACHE_KEY, queryParams, isAnonymousUser],
    queryFn: () => {
      if (areParamsForBulkServices(queryParams)) {
        return serviceRepository.getServicesForMultipleShipments(queryParams);
      }
      if (isAnonymousUser) {
        return serviceRepository.all(queryParams);
      }
      return serviceRepository.getServicesForSpecificSearch(queryParams);
    },
    enabled: !!queryParams
  });
  handleFetchLoading(isLoading);
  useEffect(() => {
    if (error) {
      onFetchError === null || onFetchError === void 0 ? void 0 : onFetchError(ServiceListEvents.SERVICES, error);
    }
  }, [error, onFetchError]);
  useEffect(() => {
    data && saveFetchedServices(data);
  }, [data, saveFetchedServices]);
}

export { useFetchServices };
//# sourceMappingURL=useFetchServices.js.map
